<!-- 自定义组件，级联选择器 -->
<template>
    <div class="TTL-select" :style="{width:option.width}">
        <el-cascader 
            ref="cascaderRef"
            v-model="selectvalue" 
            :options="list"
            :props="option.props"
            :placeholder="option.placeholder" 
            :filterable="option.filterable" 
            :clearable="option.clearable"
            :disabled="cascaderDisabled"
            @change="changeData"
        />
    </div>
</template>

<script>
export default {
  props: {
      value: {},
      list: {},
      option: {},
      disabled: {
          type: Boolean,
          default: false,
      },
  },
  data() {
      return {
          selectvalue: this.value,
          selectlist: this.list,
          option: {
              placeholder:this.option && this.option.placeholder ? this.option.placeholder : '请选择数据',
              clearable: this.option && this.option.clearable ? this.option.clearable : false,
              filterable: this.option && this.option.filterable ? this.option.filterable : false,
              width: this.option && this.option.width ? this.option.width+'px' : '220px',
              props: this.option && this.option.props ? this.option.props : {},
              closeOnSelect: this.option && this.option.closeOnSelect ? this.option.closeOnSelect : false,
          },
      }
  },

  computed: {
      cascaderDisabled() {
          const opt = this.$props.option;
          return !!(this.disabled || (opt && opt.disabled));
      },
  },

  watch: {
      value(val) {
          this.selectvalue=val;
      },
      list(val) {
          this.selectlist=val;
      },
  },

  methods: {
      hideCascaderPanel() {
        const cascader = this.$refs.cascaderRef;
        if (!cascader) return;
        if (typeof cascader.togglePopperVisible === 'function') {
            cascader.togglePopperVisible(false);
        }
        if (Object.prototype.hasOwnProperty.call(cascader, 'dropDownVisible')) {
            cascader.dropDownVisible = false;
        }
        if (Object.prototype.hasOwnProperty.call(cascader, 'popperVisible')) {
            cascader.popperVisible = false;
        }
      },

      changeData() {
        var datavalue=this.selectvalue;
        var result={pcateid:0,pcatename:'',scateid:0,scatename:''};
        var pcateid=0;
        var scateid=0;
        var children=[];
        if(datavalue) {
            pcateid=datavalue[0];
            result.pcateid=pcateid;
            children=[];
            for(var i in this.selectlist) {
                if(this.selectlist[i].value==pcateid) {
                    result.pcatename=this.selectlist[i].label;
                    children=this.selectlist[i].children;
                }
            }
            if(datavalue.length > 1) {
                scateid=datavalue[1];
                result.scateid=scateid;
                for(var i in children) {
                    if(children[i].value==scateid) {
                        result.scatename=children[i].label;
                    }
                }
            }
        }
        result.value = datavalue || [];
        this.$emit('finish',result);
        if(this.option.closeOnSelect && Array.isArray(datavalue) && datavalue.length > 0) {
            this.$nextTick(() => {
                this.hideCascaderPanel();
                setTimeout(() => {
                    this.hideCascaderPanel();
                }, 0);
            });
        }
      },
  }
}
</script>

<style scoped>
.TTL-select .el-select {width:100%}
</style>
